import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllCaseManagers, fetchCaseManagers, resetCaseManagersStatus} from '../../reducers/case-managers-slice';
import { useEffect, useState } from 'react';



const ReassignCaseManagerModal = ({ showReassignCaseManagerModal, handleCloseReassignCaseManagerModal, handleReassignButton, handleReassignChange, orderIds, firmNames }) => {
    const dispatch = useDispatch();

        // fetch case managers
        const [caseManagersLoaded, setCaseManagersLoaded] = useState(false);
        const [btnDisabled, setBtnDisabled] = useState(false);
        const caseManagers = useSelector(selectAllCaseManagers);
        const caseManagersStatus = useSelector(state => state.caseManagers.status);
    
        // fetch case managers on each initial render
        useEffect(() => {
            if (caseManagersStatus === 'idle' && !caseManagersLoaded) {
                dispatch(fetchCaseManagers());
            } else if (caseManagersStatus === 'succeeded' && !caseManagersLoaded) {
                // anything that needs to happen AFTER 
                // the data has loaded (e.g. removing loading indicator)
                setCaseManagersLoaded(true);
            }
        }, [dispatch, caseManagersStatus, caseManagersLoaded]);
    
        // if a user has been updated, rerender
        useEffect(() => {
            if (caseManagersStatus === 'idle') {
                dispatch(fetchCaseManagers());
            } 
        }, [dispatch, caseManagersStatus]);
    
        // set when case managers details have been loaded
        useEffect(() => {
            if (caseManagersLoaded) {
                dispatch(resetCaseManagersStatus());
            }
        }, [dispatch, caseManagersLoaded]);

        const handleButtonClick = (e) => {
            setBtnDisabled(true);
            handleReassignButton(e);
        }

     // Check if all firm names in the array are the same
    const firmNameMatch = firmNames.every(x => x === firmNames[0]);
    // Find all users associated with the matched firm
    const usersInMatchingFirm = firmNameMatch ? caseManagers.filter(x => x.lawFirm === firmNames[0]) : '';

    return (
        <Modal
            backdrop="static"
            show={showReassignCaseManagerModal}
            onHide={handleCloseReassignCaseManagerModal}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Assign all selected orders to:</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {(orderIds.length === 0 && firmNames.length === 0) ? <div>Please select at least one order to assign a case manager to.</div> : (!firmNameMatch) ? <div>***All orders selected must be under the same Law Firm to reassign a case manager***</div> : ''}
                <p><strong>Case Manager</strong></p>
                <Form.Select onChange={handleReassignChange}>
                    <option>Select a Case Manager</option>
                    {usersInMatchingFirm  && usersInMatchingFirm.map(data => {
                        return <option key={data.id} value ={data.id}>{data.firstName} {data.lastName}</option>
                    })}
                </Form.Select>
            </Modal.Body>

            <Modal.Footer>
                <button className="button tertiary" disabled={btnDisabled} onClick={handleButtonClick}>Assign</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReassignCaseManagerModal;